/* eslint-disable no-prototype-builtins */

export class EventEmitter<Events extends Record<string, unknown[]>> {
  private listeners: {
    [key in keyof Events]?: Array<(...args: Events[key]) => void>
  } = {}

  addListener = <K extends keyof Events>(
    event: K,
    callback: (...args: Events[K]) => void
  ) => {
    if (!this.listeners.hasOwnProperty(event)) {
      this.listeners[event] = []
    }

    if (this.listeners[event]) {
      this.listeners[event]!.push(callback)
    }

    return this
  }

  removeListener = <K extends keyof Events>(
    event: K,
    callback: (...args: Events[K]) => void
  ) => {
    if (!this.listeners.hasOwnProperty(event)) {
      return this
    }

    const collection = this.listeners[event]!

    for (let i = 0; i < collection.length; i++) {
      if (collection[i] === callback) {
        collection.splice(i, 1)
        break
      }
    }

    return this
  }

  // aliases
  on = this.addListener
  off = this.removeListener

  emit<K extends keyof Events>(event: K, ...data: Events[K]) {
    if (!this.listeners.hasOwnProperty(event)) {
      return null
    }

    const collection = this.listeners[event]!

    for (let i = 0; i < collection.length; i++) {
      const callback = collection[i]

      if (callback) callback.call(this, ...data)
    }
  }
}
